import { render, staticRenderFns } from "./ModalAddFactSignatoryRule.vue?vue&type=template&id=2456cab4&scoped=true&"
import script from "./ModalAddFactSignatoryRule.vue?vue&type=script&lang=js&"
export * from "./ModalAddFactSignatoryRule.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2456cab4",
  null
  
)

export default component.exports